import React, {useState, useMemo} from "react";

import { marked } from "marked";
import { sanitize } from 'dompurify';
import './style/utils.css'


// https://github.com/markedjs/marked/issues/655
const renderer = new marked.Renderer();
const linkRenderer = renderer.link;
renderer.link = (href, title, text) => {
  const localLink = href.startsWith(`${window.location.protocol}//${window.location.hostname}`);
  const html = linkRenderer.call(renderer, href, title, text);
  return localLink ? html : html.replace(/^<a /, `<a target="_blank" rel="noreferrer noopener nofollow" `);
};

const render_with_marked = (markdown) => {
  return marked(markdown, { renderer })
}

// extract urls and wrap them into <a/> components
// opts: specify what to extract
// (if key a is false => no a is extracted: to avoid links embedded in links)
function processText(txt, opts) {
  const url_pattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/

  const elems = txt.split(url_pattern).map((x, i) => {

    if (opts.a && x.match(url_pattern)) {
      let url = x;
      // an url without http(s) will be interpreted as local to this site
      // Don't, except if this is current site: prefix w/ https
      if (!x.startsWith("http") && !x.startsWith(window.location.hostname)) {
        url = "https://" + url;
      }

      return <a key={i} href={url} target="_blank" rel="noreferrer noopener">{ x }</a>
    } else {
      return <span key={i}>{ x }</span>
    }
  })

  return <>{ elems }</>;
}

// transform a string into react components
function toRichText(txt, opts = {}) {
  opts = {a: true, ...opts};
  return <div className="richtext">
    { processText(txt || "", opts) }
  </div>

}

const markdownToHTML = (txt) => {
  const html = render_with_marked(txt);

  // prevent sanitize from
  // https://github.com/cure53/DOMPurify/issues/317
  const sanitized = sanitize(
    html,
    {
      USE_PROFILES: { html: true },
      ADD_ATTR: ['target']
    }
  );
  return sanitized;
}

const MarkdownElement = ({text}) => {
  const html = useMemo(() => markdownToHTML(text), [text]);

  return <div className="markdown" dangerouslySetInnerHTML={{__html: html}} />;
}



export { toRichText, markdownToHTML, MarkdownElement }
